// Package imports
import React from 'react';
import { Link } from 'react-router-dom';

// CSS imports
import './Home.css';

// Component imports
import FlexSystem from '../../components/flexSystem/flexSystemContainer/FlexSystem';
import FlexSystemItem from '../../components/flexSystem/flexSystemItem/FlexSystemItem';
import IconCard from '../../components/iconCard/IconCard';

// Helper imports
import SectionWrapper from '../../helpers/components/sectionWrapper/SectionWrapper';

// Icon imports
// import { HiOutlineMail } from 'react-icons/hi';
import { LuNewspaper } from 'react-icons/lu';
// import { FaRegNewspaper } from 'react-icons/fa';
// import { FaUser } from 'react-icons/fa';

// Type imports
import { SectionContentSize } from '../../types/sectionWrapper/SectionContentSize';

const Home: React.FC = () => {
  return (
    <div className='Home'>
      <SectionWrapper contentWidth={SectionContentSize.MEDIUM}>
        <FlexSystem>
          {/* <FlexSystemItem itemSize={6}>
            <Link to='/email-templates'>
              <IconCard title='Email Templates' ReactIcon={HiOutlineMail} />
            </Link>
          </FlexSystemItem> */}
          <FlexSystemItem itemSize={6}>
            <Link to='/blog'>
              <IconCard title='Blog' ReactIcon={LuNewspaper} />
            </Link>
          </FlexSystemItem>
          {/* <FlexSystemItem itemSize={6}>
            <Link to='/newsletter-emails'>
              <IconCard title='Newsletter Emails' ReactIcon={FaRegNewspaper} />
            </Link>
          </FlexSystemItem>
          <FlexSystemItem itemSize={6}>
            <Link to='/newsletter-users'>
              <IconCard title='Newsletter Users' ReactIcon={FaUser} />
            </Link>
          </FlexSystemItem> */}
        </FlexSystem>
      </SectionWrapper>
    </div>
  );
};

export default Home;
